import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-729504f2")

_pushScopeId("data-v-729504f2")
const _hoisted_1 = { class: "cards flex flex-wrap" }
const _hoisted_2 = { class: "image" }
const _hoisted_3 = { class: "card-text" }
const _hoisted_4 = { class: "selected" }
const _hoisted_5 = { class: "tags" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_empty = _resolveComponent("el-empty")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_tag = _resolveComponent("el-tag")
  const _component_el_card = _resolveComponent("el-card")
  const _component_card_tag_editor = _resolveComponent("card-tag-editor")
  const _component_el_drawer = _resolveComponent("el-drawer")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_el_page_header, {
      onBack: _ctx.goBack,
      content: `卡牌列表: ${_ctx.keyword}`
    }, null, 8, ["onBack", "content"]),
    (_ctx.cards.length === 0)
      ? (_openBlock(), _createBlock(_component_el_empty, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.cards, (card) => {
        return (_openBlock(), _createBlock(_component_el_card, {
          class: "card",
          key: card
        }, {
          default: _withId(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_el_image, {
                onClick: ($event: any) => (_ctx.clickCard(card)),
                class: "image",
                src: card.cardUrl
              }, null, 8, ["onClick", "src"]),
              _createVNode("div", _hoisted_3, _toDisplayString(card.cardText), 1),
              _createVNode("div", _hoisted_4, [
                _createVNode(_component_el_popconfirm, {
                  class: "block",
                  onConfirm: ($event: any) => (_ctx.removeCard(card.id)),
                  title: "确定删除吗？"
                }, {
                  reference: _withId(() => [
                    _createVNode(_component_el_button, {
                      type: "danger",
                      size: "mini",
                      circle: "",
                      icon: "el-icon-close"
                    })
                  ]),
                  _: 2
                }, 1032, ["onConfirm"])
              ])
            ]),
            _createVNode("div", _hoisted_5, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(card.cardTags, (cardTag) => {
                return (_openBlock(), _createBlock(_component_el_tag, { key: cardTag }, {
                  default: _withId(() => [
                    _createTextVNode(_toDisplayString(_ctx.getTagName(cardTag.tagId)), 1)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ])
          ]),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createVNode(_component_el_drawer, {
      title: "打标签",
      size: "40%",
      modelValue: _ctx.tagsPanelVisible,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.tagsPanelVisible = $event)),
      direction: "rtl"
    }, {
      default: _withId(() => [
        _createVNode(_component_card_tag_editor, {
          card: _ctx.selectedCard,
          "original-image-tags": _ctx.originalImageTags,
          "primary-tag-name": _ctx.cardKeyword?.keyword
        }, null, 8, ["card", "original-image-tags", "primary-tag-name"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})